/**
 * Copyright © 2018 Emu Analytics
 */

import { ITileSpec } from './api-interfaces';
import { Client } from './client';

export class TileEndpoints {
  constructor(private readonly client: Client) {}

  getTileSpec(tilesourceId: string, params: Record<string, any> = {}): Promise<ITileSpec> {
    return this.client._get(`/tiles/${tilesourceId}/index.json`, { params });
  }

  getPreviewStyle(tilesourceId: string, params: Record<string, any> = {}): Promise<ITileSpec> {
    return this.client._get(`/tiles/${tilesourceId}/style.json`, { params });
  }
}
